import { render, staticRenderFns } from "./HomeIntro.vue?vue&type=template&id=71a6528d&scoped=true&"
import script from "./HomeIntro.vue?vue&type=script&lang=js&"
export * from "./HomeIntro.vue?vue&type=script&lang=js&"
import style0 from "./HomeIntro.vue?vue&type=style&index=0&id=71a6528d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6528d",
  null
  
)

export default component.exports